import React, { useEffect } from "react"; // Ajout de useEffect
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom"; // Ajout de useLocation
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Hebergements from "./pages/Hebergements";
import HebergementDetail from "./pages/HebergementDetail";
import Activites from "./pages/Activites";
import ActiviteDetail from "./pages/ActiviteDetail";
import Sejours from "./pages/Sejours";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";
import CookieConsent from "react-cookie-consent";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <CookieConsent
          location="bottom"
          buttonText="J'accepte"
          declineButtonText="Je refuse"
          enableDeclineButton
          cookieName="natureCevennesConsent"
          style={{ background: "#afab53", color: "#fff", alignItems: "center" }}
          buttonStyle={{ background: "#827d2fff", color: "white", borderRadius: "5px", padding: "10px 20px" }}
          declineButtonStyle={{ background: "transparent", border: "1px solid   #ffffffff", borderRadius: "5px" }}
          expires={150}
        >
          Ce site utilise des cookies pour analyser notre trafic et améliorer votre expérience.
        </CookieConsent>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hebergements" element={<Hebergements />} />
          <Route path="/hebergements/:slug" element={<HebergementDetail />} />
          <Route path="/activites" element={<Activites />} />
          <Route path="/activites/:slug" element={<ActiviteDetail />} />
          <Route path="/sejours" element={<Sejours />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;